const IMAGE_LAYOUT = 'image-layout';
const DEFAULT_LAYOUT = 'default-layout';

export { DEFAULT_LAYOUT, IMAGE_LAYOUT };
